import { styled } from '@mui/material/styles'
import clsx from 'clsx'
import React, { type ReactNode } from 'react'
import { useRecordContext } from 'react-admin'
import { border, xxllncColor } from '../../layout/themes'

const SHOW_BY_DEFAULT = 3

interface AppFieldProps {
  source: string
  className?: string
  emptyText?: string
}

type AnyRecord = Record<string, unknown>

export const AppField: React.FC<AppFieldProps> = ({ source, className, emptyText }) => {
  const record = useRecordContext<AnyRecord>()

  // eslint-disable-next-line security/detect-object-injection
  const raw = record ? record[source] : undefined
  const apps: string[] | undefined = Array.isArray(raw)
    ? (raw as unknown[]).filter((v): v is string => typeof v === 'string')
    : undefined

  const content: ReactNode = record ? (
    <>
      {apps?.slice(0, SHOW_BY_DEFAULT).map(item => (
        <div key={item} className={classes.item}>
          {item}
        </div>
      ))}
      {apps && apps.length > SHOW_BY_DEFAULT && (
        <div className={classes.more}>+{apps.length - SHOW_BY_DEFAULT}</div>
      )}
      {(!apps || apps.length === 0) && emptyText ? <span>{emptyText}</span> : null}
    </>
  ) : null

  return <Root className={clsx(classes.root, className)}>{content}</Root>
}

AppField.displayName = 'AppField'

const PREFIX = 'xxllncAppField'
const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}-item`,
  more: `${PREFIX}-more`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.item}`]: {
    backgroundColor: xxllncColor.opDark10,
    border: `${border.thin} solid ${xxllncColor.opDark10}`,
    borderRadius: border.radius.lg,
    fontSize: 14,
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
  },
  [`& .${classes.more}`]: {
    backgroundColor: xxllncColor.opDark10,
    border: `${border.thin} solid transparent`,
    borderRadius: border.radius.lg,
    fontSize: 14,
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
  },
}))
